"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImplementationTemplatesClient = void 0;
const tslib_1 = require("tslib");
const authenticated_client_1 = require("./authenticated.client");
class ImplementationTemplatesClient extends authenticated_client_1.AuthenticatedClient {
    getAll() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = '/v1/implementation-templates';
            const response = yield this.httpGet(url);
            return response.payload;
        });
    }
}
exports.ImplementationTemplatesClient = ImplementationTemplatesClient;
//# sourceMappingURL=implementation-templates.client.js.map